import { useFetchProfile } from '@/hooks/useFetchProfile'
import { NostrUser } from '@nostr/gadgets/metadata'
import { Skeleton } from './ui/skeleton'
import { cn } from '@/lib/utils'

export default function SimpleUsername({
  user,
  className,
  skeletonClassName,
  withoutSkeleton = false
}: {
  user: string | NostrUser
  className?: string
  skeletonClassName?: string
  withoutSkeleton?: boolean
}) {
  const { profile, isFetching } = useFetchProfile(user)
  if (isFetching && !withoutSkeleton) {
    return (
      <div className="py-1">
        <Skeleton className={cn('w-16', skeletonClassName)} />
      </div>
    )
  }
  if (!profile) return null

  const { shortName } = profile

  return <div className={className}>{shortName}</div>
}
